import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import socialPrintTemplateStrings from './contextualStrings';
import ContextualString from '../../../../../../../../components/contextual/ContextualString';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const SocialPrintTemplateWGJoinCode = ({ albumFolder, account }) => {
  return (
    <Fragment>
      <p className="marketing-material-social-main-copy">
        <ContextualString
          id="webGalleryMainCopy"
          defaultMessage="{orgName} is excited to announce that you’ll be able to view, download, and share all your favorite photos through our Waldo Photos gallery!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={socialPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>
      <p
        className="marketing-material-social-cta-copy"
        style={{ bottom: '34%' }}
      >
        Head to <span>waldophotos.com/galleries</span> and insert our join code
        below:
      </p>
      <p
        className="marketing-material-social-target-copy text-uppercase"
        style={{ bottom: '30%' }}
      >
        {albumFolder.join_code}
      </p>
    </Fragment>
  );
};

SocialPrintTemplateWGJoinCode.propTypes = propTypes;

export default SocialPrintTemplateWGJoinCode;
